import { PropsWithChildren } from 'react';
import { useAppointmentControlInKiosk } from './hooks/useAppointmentControlInKiosk';

export const KioskAppointmentControlLayout = ({
  children,
}: PropsWithChildren) => {
  useAppointmentControlInKiosk();
  return children;
};
